import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'

export class DisplaySplashScreenState extends BaseState {
    public begin() {
        GameSignals.completeSplashScreenState.connect(this.end)
        GameSignals.displaySplashScreenState.emit()
    }

    public end = () => {
        this._stateMachine.setState(GameStatesEnum.RESTORE_STATE)
    }

    public cleanUp() {
        GameSignals.completeSplashScreenState.disconnect(this.end)
    }
}
